import { createContext } from 'react';

import type { CookieValues, SetCookieOptions } from '~/hooks/useUtils/useCookies';

export interface PageContextType {
  cookies: CookieValues;
  setCookie: (options: SetCookieOptions) => void;
  removeCookie: (name: SetCookieOptions['name']) => void;
  cookiesSet?: boolean;
  visitToken?: string;
  referralId?: string;
  currentPath: string;
}

export const PageContext = createContext<PageContextType | undefined>(undefined);
